function Footer() {
    return (
        <footer style={{
            backgroundColor: "#b3e5fc",
            padding: "20px",
            margin: "0px",
            textAlign: "center",
            fontSize: "8px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)"
        }}>
            <h1>© 2025 React Assignment. All Rights Reserved.</h1>
        </footer>
    );
}   
export default Footer;